export const setEventosActivos = (state, eventos) => {
    state.eventosactivos = eventos
}

export const setEventosActivosExhibicion = (state, eventosexhibicion) => {
    state.eventosactivosexhibicion = eventosexhibicion
}
